import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=645d1e32&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=645d1e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d1e32",
  null
  
)

export default component.exports